export default __webpack_public_path__ + "static/media/next_icon.060dcdd0.svg";